import request from '@/utils/request'

/**
 * 获取当前用户的专属水印列表及平台水印预览
 */
export function getUserWatermarks(data = {}) {
  return request({
    url: '/api/user/watermarks',
    method: 'get',
    params: data
  })
}

/**
 * 上传当前用户的专属水印
 */
export function createUserWatermark(data) {
  const multipart = typeof FormData !== 'undefined' && data instanceof FormData
  return request({
    url: '/api/user/watermarks',
    method: 'post',
    data,
    headers: multipart ? { 'Content-Type': 'multipart/form-data' } : undefined,
    suppressErrorMessage: true
  })
}

/**
 * 删除当前用户的专属水印
 */
export function deleteUserWatermark(id) {
  return request({
    url: `/api/user/watermarks/${encodeURIComponent(String(id))}`,
    method: 'delete',
    suppressErrorMessage: true
  })
}

/**
 * 获取用户详情
 * */
export function getUserInfo(data) {
  return request({
    url: '/api/user/account',
    method: 'get',
    params: data
  })
}

/**
 * 获取当前用户积分消费记录
 */
export function getUserPointsLogList(data) {
  return request({
    url: '/api/user/points-log/list',
    method: 'get',
    params: data
  })
}

/**
* 用户登录
* */
export function login(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data
  })
}

/**
 * 获取谷歌授权地址
 * */
export function getGoogleAuthUrl(data) {
  return request({
    url: '/api/google/website-auth',
    method: 'get',
    params: data
  })
}

/**
 * 获取谷歌授权情况
 * */
export function getGoogleAuthInfo(data) {
  return request({
    url: '/api/google/website-auth-info',
    method: 'post',
    data
  })
}

/**
* 用户退出登录
* */
export function logout() {
  return request({
    url: '/api/user/logout',
    method: 'post'
  })
}

/**
 * 用户注册
 * */
export function register(data) {
  return request({
    url: '/api/user/register',
    method: 'post',
    data
  })
}
export function deleteAccount(data) {
  return request({
    url: '/api/user/delete-user',
    method: 'post',
    data
  })
}

/**
 * 手机注册获取验证码
 * */
export function getRegPhoneCode(data) {
  return request({
    url: '/api/user/get-reg-phone-code',
    method: 'post',
    data
  })
}

/**
 * 邮箱注册获取验证码
 * */
export function getRegEmailCode(data) {
  return request({
    url: '/api/user/get-reg-email-code',
    method: 'post',
    data
  })
}

/**
 * 获取用户中心验证码
 * */
export function getSysSMSCode(data) {
  return request({
    url: '/api/user/get-sys-phone-code',
    method: 'post',
    data
  })
}

/**
 * 获取用户中心验证码
 * */
export function getSysEmailCode(data) {
  return request({
    url: '/api/user/get-sys-email-code',
    method: 'post',
    data
  })
}

/**
 * 获取换绑reset_token
 * */
export function getEmailResetToken(data) {
  return request({
    url: '/api/user/get-reset-email-token',
    method: 'post',
    data
  })
}

/**
 * 绑定新邮箱
 * */
export function BindNewEmail(data) {
  return request({
    url: '/api/user/get-reset-bind-email',
    method: 'post',
    data
  })
}
/**
 * 新添加绑定邮箱
 * */
export function addNewEmail(data) {
  return request({
    url: '/api/user/bind-new-email',
    method: 'post',
    data
  })
}

/**
 * 重置密码
 * */
export function resetPwdByValidCode(data) {
  return request({
    url: '/api/user/reset-pwd-by-code',
    method: 'post',
    data
  })
}

// 获取重置密码验证码
export function getResetToken(data) {
  return request({
    url: '/api/user/get-reset-token',
    method: 'post',
    data
  })
}

export function getResetPwdByToken(data) {
  return request({
    url: '/api/user/reset-pwd-by-token',
    method: 'post',
    data
  })
}
export function getResetPhoneToken(data) {
  return request({
    url: '/api/user/get-reset-phone-token',
    method: 'post',
    data
  })
}

export function rePhoneBind(data) {
  return request({
    url: '/api/user/get-reset-bind-phone',
    method: 'post',
    data
  })
}

export function updateBaseUserInfo(data) {
  return request({
    url: '/api/user/update-base-user-info',
    method: 'post',
    data
  })
}

/**
* 切换身份
* */
export function switchCurrIdentity(data) {
  return request({
    url: '/api/user/switch-curr-identity',
    method: 'post',
    data
  })
}

/**
 * 获取用户系统配置
 * */
export function getClientSysConfig(data) {
  return request({
    url: '/api/client/sys/config',
    method: 'get',
    params: data
  })
}

/**
 * 获取游客可见的客户端系统配置。
 * 仅允许后端公开的白名单配置项（例如首页智能体展示映射）。
 */
export function getPublicClientSysConfig(data) {
  return request({
    url: '/api/client/sys/public-config',
    method: 'get',
    params: data
  })
}
/**
 * 获取所有偏好设置列表
 * */
export function getPreferenceConfigs(data) {
  return request({
    url: '/api/user/get-preference-configs',
    method: 'get',
    data
  })
}
/**
 * 获取用户当前偏好
 * */
export function getUserPreference(data) {
  return request({
    url: '/api/user/get-user-preference',
    method: 'post',
    data
  })
}
/**
 * 更新当前用户偏好设置
 * */
export function updateUserPreference(data) {
  return request({
    url: '/api/user/update-user-preference',
    method: 'post',
    data
  })
}

/**
 * 创建创建checkout-session
 * */
export function createCheckoutSession(data) {
  return request({
    url: '/api/user/create-checkout-session',
    method: 'post',
    data
  })
}

/**
 * 获取当前环境可用的支付渠道
 */
export function getPaymentMethodList(data = {}) {
  return request({
    url: '/api/payment/get-pay-method-list',
    method: 'post',
    data
  })
}

/**
 * 获取用户默认支付方式
 * */
export function getDefaultPaymentMethod(data) {
  return request({
    url: '/api/user/get-default-payment-method',
    method: 'get',
    params: data
  })
}

/**
 * 获取用户默认支付方式
 * */
export function getCurrSubscription(data) {
  return request({
    url: '/api/user/get-curr-subscription',
    method: 'get',
    params: data
  })
}

/**
 * 获取stripeKey
 * */
export function getStripeKey(data) {
  return request({
    url: '/api/user/get-stripe-key',
    method: 'get',
    params: data
  })
}

/**
 * 创建设置意向
 * */
export function createSetupIntent(data) {
  return request({
    url: '/api/user/create-setup-intent',
    method: 'post',
    data
  })
}

/**
 * 更新支付方式
 * */
export function updatePaymentMethod(data) {
  return request({
    url: '/api/user/update-payment-method',
    method: 'post',
    data
  })
}
/**
 * 取消/恢复 订阅接口
 * */
export function handleSubscription(data) {
  return request({
    url: '/api/user/handle-subscription',
    method: 'post',
    data
  })
}

/**
 * 用户心跳检测
 * @returns {*}
 */
export function verifyUserHeartbeat() {
  return request({
    url: '/api/user/user-heartbeat',
    method: 'get'
  })
}

/**
 * 获取随机头像
 * @returns {*}
 */
export function getRandomAvatar() {
  return request({
    url: '/api/user/get-random-avatar',
    method: 'get'
  })
}

